import api from "../../service/api";
import { getStorage } from "../../utilities/browserStorage";

export const CreateWorkflow = async (data) => {
    let path  = `practice/claim-workflows/`;
    return api.post(path,data)
}

export const GetWorkflowList = async (practice) => {
    let path = `practice/claim-workflows/?practice=${practice}`;
    return api.get(path);
} 

export const GetWorkflow = async (id) => {
    let path = `practice/claim-workflows/${id}`;
    return api.get(path)
}

export const UpdateWorkflow = async (data,id) => {
    let path = `/practice/claim-workflows/${id}`;
    return api.put(path,data);
}

export const DeleteProcess = async (id) => {
    let path = `practice/claim-workflows/${id}`;
    return api.destroy(path)
}

export const GetFieldGroup = async () => {
    let path = "practice/list-field-groups";
    return api.get(path);
}
export const UpdateGlobalWorkflowSettings = async (data) => {
    let path = `practice/global-workflow-settings/`;
    return api.patch(path, data);
}

export const GetRoles = async (id) => {
    let path;
    if (getStorage('isAdminModule') === 'true') {
        path = `user/staff-user-roles/`;
    } else {
        path = `practice/practice-role/?practice_pk=${id}`;
    }
    return await api.get(path);
}